export class ExtraInfo {
    redirectSource?: any;
    redirectData?: any;
    calledFrom?: string;
}